import React from 'react';
import { Layers, Calendar, Bus, Clock, ShieldCheck } from 'lucide-react';

export const SchoolERPModule: React.FC = () => {
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm space-y-6">
      <div className="flex items-center justify-between border-b border-slate-100 pb-4">
        <div>
          <span className="px-2.5 py-0.5 bg-blue-100 text-blue-800 text-[10px] font-bold rounded-full uppercase tracking-wider">
            PowerSchool & Fedena Benchmark
          </span>
          <h2 className="text-2xl font-bold text-slate-900 mt-1">Special School ERP & Timetable</h2>
          <p className="text-xs text-slate-500">Adaptive classroom scheduling, special transport routes, and staff management</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-3">
          <h3 className="text-xs font-bold text-slate-700 uppercase tracking-wider flex items-center gap-1.5">
            <Bus className="w-4 h-4 text-blue-600" />
            Special Transport Bus Routes
          </h3>
          <div className="text-xs space-y-2">
            <div className="p-2.5 bg-white border rounded-lg flex items-center justify-between">
              <div>
                <div className="font-bold text-slate-900">Route 4 - Wheelchair Accessible Bus</div>
                <div className="text-[10px] text-slate-500">Driver: Rajesh Kumar | 8 Students</div>
              </div>
              <span className="text-[10px] font-bold px-2 py-0.5 bg-emerald-100 text-emerald-800 rounded">On Route</span>
            </div>
          </div>
        </div>

        <div className="md:col-span-2 p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-3">
          <h3 className="text-xs font-bold text-slate-700 uppercase tracking-wider flex items-center gap-1.5">
            <Calendar className="w-4 h-4 text-blue-600" />
            Today's Adaptive Class Schedule
          </h3>
          <div className="grid grid-cols-3 gap-3 text-xs">
            <div className="p-3 bg-white border rounded-lg">
              <div className="font-bold text-blue-600">09:00 - 10:00 AM</div>
              <div className="font-extrabold text-slate-900">Speech & AAC Session</div>
              <div className="text-[10px] text-slate-500">Room 102 (Sensory Friendly)</div>
            </div>
            <div className="p-3 bg-white border rounded-lg">
              <div className="font-bold text-blue-600">10:15 - 11:15 AM</div>
              <div className="font-extrabold text-slate-900">Occupational Therapy</div>
              <div className="text-[10px] text-slate-500">Hydrotherapy Gym</div>
            </div>
            <div className="p-3 bg-white border rounded-lg">
              <div className="font-bold text-blue-600">11:30 - 12:30 PM</div>
              <div className="font-extrabold text-slate-900">Adaptive Vocational Math</div>
              <div className="text-[10px] text-slate-500">Lab B</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
